<template>
    <div :class="styleMain">
      <el-slider v-model="value" :step="step" :show-tooltip="false" @change="change"/>
    </div>
</template>

<script>
export default {
  name: 'SportFootballMatchActionTeam',
  props: {
    action: Object
  },
  data () {
    return {
      step: 100,
      state: null
    }
  },
  computed: {
    styleMain () { return ['sportFootballMatchActionTeam', this.action.homeAway] },
    value: {
      get () { return this.action.homeAway === 'home' ? 0 : (this.action.homeAway === 'away' ? 100 : 50) },
      set (value) { this.state = value }
    }
  },
  methods: {
    change () {
      let teamId = null
      let team2Id = null
      if (this.state === 0) {
        teamId = this.action.match.teamHomeId
        team2Id = this.action.match.teamAwayId
      } else if (this.state === 100) {
        teamId = this.action.match.teamAwayId
        team2Id = this.action.match.teamHomeId
      }

      if (teamId !== this.action.teamId && team2Id !== this.action.team2Id) {
        const data = {
          id: this.action.id,
          personId: null,
          person2Id: null,
          teamId: teamId,
          team2Id: team2Id
        }

        this.$store.dispatch('Sport/Football/Match/putAction', data)
      }
    }
  }
}
</script>

<style>
.sportFootballMatchActionTeam {
  grid-area: team;
  display:flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  box-sizing:border-box;
  width:100%;
  padding:0 15%;
}
.sportFootballMatchActionTeam > div{
  flex:1;
  width:100%
}
.sportFootballMatchActionTeam .el-slider__runway{
  height:20px;
  margin:0;
  border-radius: 10px;
  background-color:var(--color-background-grey-dark);
}
.sportFootballMatchActionTeam .el-slider__button-wrapper{
  height:20px;
  width:20px;
  top:0
}
.sportFootballMatchActionTeam .el-slider__bar{
  top:0;
  height:20px;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
  background-color:var(--color-background-grey-dark);
}
.sportFootballMatchActionTeam .el-slider__button{
  background-color: white;
  border-color: var(--color-background-grey-dark);
}
.sportFootballMatchActionTeam.home .el-slider__button{
  background-color: var(--color-team-home);
  border-color: var(--color-team-home);
}
.sportFootballMatchActionTeam.away .el-slider__button{
  background-color: var(--color-team-away);
  border-color: var(--color-team-away);
}
</style>
